import React from "react";
import PageWithConfigurator from "../../shared/pageWithConfigurator/pageWithConfigurator";

import IntroRevenueModule from "./modules/IntroRevenue/index";
import NumOfIntrosModule from "./modules/NumOfIntros/index";
import ReferralBySourceModule from "./modules/ReferralBySource/index";
import TotalRevenueModule from "./modules/TotalRevenue/index";

// TODO: move up as much as possible
// each string object afterwards has a .capitalize() property
Object.defineProperty(String.prototype, "capitalize", {
  value: function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
  },
  enumerable: false
});

const pageConfig = {
  pageName: "Marketing",
  configuratorWidth: { dark: 400, light: 360 },
  moduleList: [IntroRevenueModule, NumOfIntrosModule, TotalRevenueModule, ReferralBySourceModule]
};

const MarketingPage = ({ notifications }) => (
  <PageWithConfigurator pageConfig={pageConfig} notifications={notifications} />
);

export default MarketingPage;
